(ns ui.view.card.counterparty-diligence-screening.sub
  (:require
   [common.schema.entities.screening-profile.materialization :as sp-materialization]
   [common.util :as cu]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [ui.view.card.counterparty-diligence-screening.model :as model]
   [ui.view.card.sub :as common-sub]))

(rf/reg-sub
 ::counterparty-diligence
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities-by-id] [_ {:keys [entity-id] :as _ctx}]]
   (get entities-by-id entity-id)))

(rf/reg-sub
 ::latest-process
 (fn [[_ ctx]]
   [(rf/subscribe [::counterparty-diligence ctx])
    (rf/subscribe [::common-sub/entities ctx])])
 (fn [[counterparty-diligence entities-by-id]]
   (->> counterparty-diligence
        :counterparty-diligence/processes
        (mapv #(get entities-by-id %))
        (remove nil?)
        (sort-by :common/created-on)
        last)))

(rf/reg-sub
 ::screening-profiles
 (fn [[_ ctx]]
   [(rf/subscribe [::common-sub/entities ctx])])
 (fn [[entities-by-id]]
   (->> entities-by-id
        vals
        (filterv (fn [{:keys [entity/type]}]
                   (= type :entity.type/screening-profile)))
        (mapv (fn [screening-profile]
                (-> screening-profile
                    (update :screening-profile/counterparty-diligences
                            (fn [ids]
                              (->> ids
                                   (mapv #(get entities-by-id %))
                                   (remove :common/disabled?)
                                   (remove nil?)))))))
        (sort-by :common/created-on))))

(rf/reg-sub
 ::person-screening-profiles-by-deduplication-id
 (fn [[_ ctx]]
   [(rf/subscribe [::screening-profiles ctx])])
 (fn [[screening-profiles]]
   (->> screening-profiles
        (cu/filter-by :screening-profile/type :screening-profile-type/person)
        (p/index-by sp-materialization/person-profile->deduplication-id))))

(rf/reg-sub
 ::company-screening-profiles-by-deduplication-id
 (fn [[_ ctx]]
   [(rf/subscribe [::screening-profiles ctx])])
 (fn [[screening-profiles]]
   (->> screening-profiles
        (cu/filter-by :screening-profile/type :screening-profile-type/company)
        (p/index-by sp-materialization/company-profile->deduplication-id))))

(rf/reg-sub
 ::legal-entities
 (fn [[_ ctx]]
   [(rf/subscribe [::counterparty-diligence ctx])
    (rf/subscribe [::latest-process ctx])
    (rf/subscribe [::company-screening-profiles-by-deduplication-id ctx])
    (rf/subscribe [::person-screening-profiles-by-deduplication-id ctx])])
 (fn [[counterparty-diligence
       latest-process
       company-screening-profiles-by-deduplication-id
       person-screening-profiles-by-deduplication-id]]
   (let [legal-entities-with-key-persons (sp-materialization/find-legal-entities-from-counterparty-diligence
                                          counterparty-diligence
                                          latest-process)

         with-screening-profiles
         (->> legal-entities-with-key-persons
              (mapv
               (fn [{:keys [key-persons]
                     :as   legal-entity}]
                 (let [deduplication-id (sp-materialization/legal-entity->deduplication-id legal-entity)
                       legal-entity-screening-profile (get company-screening-profiles-by-deduplication-id deduplication-id)

                       key-persons-with-screening-profiles
                       (->> key-persons
                            (mapv
                             (fn [person]
                               (let [deduplication-id (sp-materialization/person->deduplication-id person)
                                     person-screening-profile (get person-screening-profiles-by-deduplication-id deduplication-id)]
                                 (assoc person :screening-profile person-screening-profile)))))]
                   (assoc legal-entity
                          :key-persons key-persons-with-screening-profiles
                          :screening-profile legal-entity-screening-profile)))))]
     with-screening-profiles)))

(rf/reg-sub
 ::natural-persons
 (fn [[_ ctx]]
   [(rf/subscribe [::counterparty-diligence ctx])
    (rf/subscribe [::latest-process ctx])
    (rf/subscribe [::person-screening-profiles-by-deduplication-id ctx])])
 (fn [[counterparty-diligence
       process
       person-screening-profiles-by-deduplication-id]]
   (let [persons (sp-materialization/find-persons-from-counterparty-diligence
                  counterparty-diligence
                  process)]
     (->> persons
          (mapv (fn [person]
                  (let [deduplication-id (sp-materialization/person->deduplication-id person)
                        screening-profile (get person-screening-profiles-by-deduplication-id deduplication-id)]
                    (assoc person
                           :screening-profile screening-profile))))))))

(rf/reg-sub
 ::selected-legal-entities
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/selected-legal-entities-path #{})))

(rf/reg-sub
 ::selected-natural-persons
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/selected-natural-persons-path #{})))

(rf/reg-sub
 ::expanded-table-rows
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/expanded-table-rows-path #{})))

(rf/reg-sub
 ::send-to-screening-modal-state
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/send-to-screening-modal-state-path {})))

(rf/reg-sub
 ::sending-to-screening?
 common-sub/card-state-extractor
 (fn [[state]]
   (get-in state model/sending-to-screening-path)))
